const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/swiper', {
  title: 'Carrossel - Sumicity',
  description:
    'Carrosel com cards que podem ser ajustados de acordo com a preferência',
  icon: 'slides',
  category: 'design',
  attributes,

  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
